module.exports = __webpack_public_path__ + "static/07_Care-Coordinator-circle-05d4a144ec9f5ccdc6a1064ba4bb2713.png";